import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { company } from '~/company/Company';
import ProductPropertyFilter from '~/components/ProductPropertyFilter/ProductPropertyFilter';
import { useProductChoices } from '~/hooks/useProductChoices';
import type { ProductViewProps } from '~/pages/Product/Product';

import styles from './ProductProperties.module.scss';

const ProductProperties = ({
  className,
  product,
  handleChangeOffer,
  isLoading,
}: {
  className?: string;
} & Pick<ProductViewProps, 'product' | 'handleChangeOffer' | 'isLoading'>) => {
  const currentProductFilters = useProductChoices({ product });

  if (isLoading) {
    const skeletonClassName = cn(
      styles.skeleton,
      company.is('mcosmetic') && 'rounded-full overflow-hidden',
    );

    return (
      <div className={cn(styles.root, className)}>
        <div className={styles.filterContainer}>
          <div className={styles.filterList}>
            <Skeleton containerClassName={skeletonClassName} />
            <Skeleton containerClassName={skeletonClassName} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={cn(styles.root, className)}>
      {Object.values(currentProductFilters)
        .sort((a, b) => a.sorting - b.sorting || a.order - b.order)
        .map((filter) => (
          <ProductPropertyFilter
            filter={filter}
            handleChangeOffer={handleChangeOffer}
            key={filter.type}
            withTitle={company.is('mcosmetic') && filter.type === 'colorList'}
            classes={{
              filterListContainerClassName: styles.filterContainer,
              filterListClassName: styles.filterList,
              filterItemClassName: styles.filterItem,
              itemStateClassNames: {
                passed: styles.passed,
                empty: styles.empty,
                colorList: styles.colorList,
              },
            }}
          />
        ))}
    </div>
  );
};

export default observer(ProductProperties);
